enum LocationTipsLevel {
  Off = 0,
  On = 1,
  Forced = 2,
  PromptAfterPaymentSelected = 3,
}

export { LocationTipsLevel };
